// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3723":"css/admin-app.6643","4242":"css/app.6643"}[chunkId] + ".css";
};